import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import Helper from "../../helper";
// import { getAllEvents } from "../../redux/slice/event/eventSlice";
import TableRow from "../TableRow";
import "./MobileExchangeGames.css";

const FILTERS = [
  { id: "live", label: "LIVE" },
  { id: "virtual", label: "VIRTUAL" },
  { id: "premium", label: "PREMIUM" },
];

const DATE_TABS = [
  { id: "today", label: "TODAY" },
  { id: "tomorrow", label: "TOMORROW" },
  { id: "upcoming", label: "UPCOMING" },
];

const isInplayEvent = (event) =>
  String(event?.is_inplay).toLowerCase() === "true";

const MobileExchangeGames = () => {
//   const dispatch = useDispatch();
  const userInfo = Helper();
  const eventStore = useSelector((state) => state.events);

  const [selectedFilter, setSelectedFilter] = useState(null);
  const [activeDateTab, setActiveDateTab] = useState("today");

//   useEffect(() => {
//     dispatch(
//       getAllEvents({
//         user_id: userInfo?._id || "",
//       }),
//     );
//   }, [dispatch, userInfo?._id]);

  const allEvents = useMemo(
    () =>
      (eventStore?.events || [])
        .flatMap((item) => item?.competitions || [])
        .flatMap((competition) => competition?.events || []),
    [eventStore?.events],
  );

  const exchangeEvents = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const dayAfterTomorrow = new Date(tomorrow);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 1);

    return allEvents.filter((event) => {
      const eventDate = new Date(event?.open_date);

      if (Number.isNaN(eventDate.getTime())) {
        return false;
      }

      let dateMatches = false;

      if (activeDateTab === "today") {
        dateMatches = eventDate >= today && eventDate < tomorrow;
      }

      if (activeDateTab === "tomorrow") {
        dateMatches = eventDate >= tomorrow && eventDate < dayAfterTomorrow;
      }

      if (activeDateTab === "upcoming") {
        dateMatches = eventDate >= dayAfterTomorrow;
      }

      if (!dateMatches) {
        return false;
      }

      if (selectedFilter === "live") {
        return isInplayEvent(event);
      }

      /*
       * API response me is_virtual / is_premium fields nahi hain.
       * Isliye Virtual/Premium currently date-wise all events hi show karenge.
       */
      return true;
    });
  }, [activeDateTab, allEvents, selectedFilter]);

  const handleFilterClick = (filterId) => {
    setSelectedFilter((currentFilter) =>
      currentFilter === filterId ? null : filterId,
    );
  };

  return (
    <section className="mobile-exchange-games" aria-label="Exchange games">
      <div className="mobile-exchange-games-header">
        <div className="mobile-exchange-games-heading">
          <i className="fa fa-play-circle" aria-hidden="true" />
          <span>EXCHANGE GAMES</span>
        </div>

        <div className="mobile-exchange-games-filters">
          {FILTERS.map((filter) => {
            const isSelected = selectedFilter === filter.id;

            return (
              <button
                key={filter.id}
                type="button"
                className={isSelected ? "is-selected" : ""}
                onClick={() => handleFilterClick(filter.id)}
              >
                <span>{isSelected ? "✓" : "✚"}</span>
                {filter.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mobile-exchange-games-tabs">
        {DATE_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={activeDateTab === tab.id ? "is-active" : ""}
            onClick={() => setActiveDateTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mobile-exchange-games-events">
        {exchangeEvents.map((event, index) => (
          <TableRow
            key={event?.event_id || `${event?.event_name}-${index}`}
            i={index}
            row={event}
            isMobile
            username={userInfo?._id}
            enableOddsSocket={false}
          />
        ))}
      </div>
    </section>
  );
};

export default MobileExchangeGames;
